// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // ✅ Tailwind styles applied
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ Import AuthProvider
import { AuthProvider } from './context/AuthContext';

// ✅ Create root and render App
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// ✅ Optional: Measure performance
reportWebVitals();
